import { render, staticRenderFns } from "./EditPrecioModal.vue?vue&type=template&id=d5c5f424"
import script from "./EditPrecioModal.vue?vue&type=script&lang=js"
export * from "./EditPrecioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports